module.exports = __webpack_public_path__ + "static/media/logo.26540078.svg";